import { HubConnectionState } from '@microsoft/signalr';

/**
 * Checks whether a SignalR HubConnection is in the 'Connected' state
 * and ready to send/receive messages.
 *
 * Use this instead of a bare `if (connection)` check, because a
 * connection object can exist in Disconnected / Reconnecting states
 * after the server drops or reconnect retries are exhausted.
 *
 * @param {import('@microsoft/signalr').HubConnection|null} connection
 * @returns {boolean}
 */
export const isConnectionReady = (connection) => {
  return connection != null && connection.state === HubConnectionState.Connected;
};
